import axios from "axios";

export const axiosPrivate = axios.create({
  baseURL:process.env.REACT_APP_API_URL,
  withCredentials: true,
});

axiosPrivate.defaults.headers.common["Content-Type"] = "application/json";
